// NPM Imports
import { createSelector } from "reselect";

// Internal Imports
import { DocumentUtils } from "../utils";
import { DOCUMENTS } from "../constants";

// Destructuring
const {
  checkSectionIsTableV2GSheet,
  checkSectionIsLinkedQuoteTable,
  checkSectionIsLinkedToExcel,
} = DocumentUtils;
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

export const selectComponents = state => state.DocumentStore.components;
export const selectExcelSheetId = state => state.QuotationStore.excelSheetId;

export const selectLinkedExcelTableComponents = createSelector(
  [selectComponents],
  components => {
    const linkedExcelTableComponents = [];
    Object.keys(components).forEach(componentId => {
      if (
        componentId &&
        components[componentId] &&
        components[componentId].content
      ) {
        if (checkSectionIsLinkedToExcel(components[componentId])) {
          linkedExcelTableComponents.push(components[componentId].content);
        }
      }
    });
    return linkedExcelTableComponents;
  },
);

export const selectLinkedExcelTableComponent = createSelector(
  [selectLinkedExcelTableComponents, selectExcelSheetId],
  (excelComponents, excelSheetId) => {
    let rowData;
    if (Array.isArray(excelComponents)) {
      excelComponents.forEach(comp => {
        if (comp.id === excelSheetId) {
          rowData = comp;
        }
      });
    }
    return rowData;
  },
);

export const selectLinkedQuoteTableComponents = createSelector(
  [selectComponents],
  components => {
    const linkedQuoteTableComponents = [];
    Object.keys(components).forEach(componentId => {
      if (
        componentId &&
        components[componentId] &&
        components[componentId].content
      ) {
        if (checkSectionIsLinkedQuoteTable(components[componentId])) {
          linkedQuoteTableComponents.push(components[componentId].content);
        }
      }
    });
    return linkedQuoteTableComponents;
  },
);

export const selectGsheetComponents = createSelector(
  [selectComponents],
  components => {
    const gsheetComponents = [];
    Object.keys(components).forEach(componentId => {
      if (
        componentId &&
        components[componentId] &&
        components[componentId].content
      ) {
        if (
          checkSectionIsTableV2GSheet(components[componentId]) ||
          components[componentId].content.type ===
            DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET
        ) {
          gsheetComponents.push(components[componentId].content);
        }
      }
    });
    return gsheetComponents;
  },
);

export const selectDealTableComponent = createSelector(
  [selectComponents],
  components => {
    let dealTableComponent = null;
    Object.keys(components).forEach(componentId => {
      if (
        componentId &&
        components[componentId] &&
        components[componentId].content
      ) {
        if (
          components[componentId].content.type ===
          DOCUMENT_COMPONENT_TYPES.DEAL_TABLE
        ) {
          dealTableComponent = components[componentId].content;
        }
      }
    });
    return dealTableComponent;
  },
);

export const selectQuoteTableComponent = createSelector(
  [selectComponents],
  components => {
    let quoteTableComponent = null;
    Object.keys(components).forEach(componentId => {
      if (
        componentId &&
        components[componentId] &&
        components[componentId].content
      ) {
        if (
          components[componentId].content.type ===
          DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER
        ) {
          quoteTableComponent = components[componentId].content;
        }
      }
    });
    return quoteTableComponent;
  },
);

export const selectSectionListForPlusBtn = createSelector(
  [selectComponents],
  components => {
    const sectionList = [];
    Object.keys(components).forEach(componentId => {
      if (components[componentId] && components[componentId].content) {
        const sectionObj = {
          id: componentId,
          type: components[componentId].content.type,
        };
        if (checkSectionIsTableV2GSheet(components[componentId])) {
          sectionObj.dataSource = DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET;
        }
        sectionList.push(sectionObj);
      }
    });
    return sectionList;
  },
);
